import { SheetTabStrip } from '@/components/SheetTabStrip'

export type ClientTabKey =
  | 'overview'
  | 'activity'
  | 'appointments'
  | 'documents'
  | 'clinical'
  | 'identifiers'

export const CLIENT_TAB_KEYS: readonly ClientTabKey[] = [
  'overview',
  'activity',
  'appointments',
  'documents',
  'clinical',
  'identifiers',
] as const

export const DEFAULT_CLIENT_TAB: ClientTabKey = 'overview'

export function isClientTabKey(value: string | null): value is ClientTabKey {
  return (
    value !== null && (CLIENT_TAB_KEYS as readonly string[]).includes(value)
  )
}

const TAB_LABELS: Record<ClientTabKey, string> = {
  overview: 'Overview',
  activity: 'Activity',
  appointments: 'Appointments',
  documents: 'Documents',
  clinical: 'Clinical',
  identifiers: 'Identifiers',
}

/** Counts render as a pill after the label; omit for tabs with nothing to count. */
export type ClientTabCounts = Partial<Record<ClientTabKey, number>>

/**
 * Tab strip. Render inside a `<Tabs>` root alongside the panels. `tabs` limits
 * the strip to the tabs this viewer may open; defaults to all of them.
 */
export function ClientSheetTabs({
  tabs = CLIENT_TAB_KEYS,
  counts,
}: {
  tabs?: readonly ClientTabKey[]
  counts?: ClientTabCounts
}) {
  return (
    <SheetTabStrip
      tabs={tabs.map((value) => ({
        value,
        label: TAB_LABELS[value],
        count: counts?.[value],
      }))}
    />
  )
}
